// 創建一個瀏覽器兼容版本的 youtube-player.js

// 添加全局變量來跟踪所有打開的窗口和模態對話框
const openWindows = [];
const openModals = [];

// 添加關閉所有窗口的方法
export function closeAllWindows() {
  console.log(`嘗試關閉 ${openWindows.length} 個已打開的窗口`);
  
  // 創建一個副本，因為我們會在迭代過程中修改原數組
  const windowsToClose = [...openWindows];
  let closedCount = 0;
  
  windowsToClose.forEach((window, index) => {
    try {
      if (window && !window.closed) {
        console.log(`關閉窗口 #${index + 1}`);
        
        // 嘗試多種方式關閉窗口
        try {
          // 方法 1: 使用 close() 方法
          window.close();
          closedCount++;
        } catch (closeError) {
          console.warn(`使用 close() 方法關閉窗口 #${index + 1} 失敗:`, closeError);
          
          try {
            // 方法 2: 嘗試使用 window.open('', '_self').close()
            window.open('', '_self').close();
            closedCount++;
          } catch (selfCloseError) {
            console.warn(`使用 self.close() 方法關閉窗口 #${index + 1} 失敗:`, selfCloseError);
            
            try {
              // 方法 3: 嘗試將窗口導航到空白頁面
              window.location.href = 'about:blank';
              closedCount++;
            } catch (navigateError) {
              console.error(`所有方法都無法關閉窗口 #${index + 1}:`, navigateError);
            }
          }
        }
      }
    } catch (error) {
      console.error(`關閉窗口 #${index + 1} 時出錯:`, error);
    }
  });
  
  // 清空窗口列表
  openWindows.length = 0;
  
  console.log(`成功關閉了 ${closedCount}/${windowsToClose.length} 個窗口`);
  return closedCount; // 返回關閉的窗口數量
}

// 關閉模態對話框
function closeModal(modalInfo) {
  try {
    if (modalInfo && modalInfo.modal) {
      document.body.removeChild(modalInfo.modal);
      const index = openModals.indexOf(modalInfo);
      if (index !== -1) {
        openModals.splice(index, 1);
      }
    }
  } catch (error) {
    console.error('關閉模態對話框時出錯:', error);
  }
}

// 關閉所有模態對話框
export function closeAllModals() {
  console.log(`嘗試關閉 ${openModals.length} 個已打開的模態對話框`);
  
  const modalsToClose = [...openModals];
  let closedCount = 0;
  
  modalsToClose.forEach((modalInfo, index) => {
    try {
      console.log(`關閉模態對話框 #${index + 1}`);
      closeModal(modalInfo);
      closedCount++;
    } catch (error) {
      console.error(`關閉模態對話框 #${index + 1} 時出錯:`, error);
    }
  });
  
  // 清空模態對話框列表
  openModals.length = 0;
  
  console.log(`成功關閉了 ${closedCount}/${modalsToClose.length} 個模態對話框`);
  return closedCount;
}

// 關閉所有打開的窗口和模態對話框
export function closeAll() {
  console.log('嘗試關閉所有打開的窗口和模態對話框');
  
  const windowsCount = closeAllWindows();
  const modalsCount = closeAllModals();
  
  console.log(`總共關閉了 ${windowsCount} 個窗口和 ${modalsCount} 個模態對話框`);
  return { windowsCount, modalsCount };
}

// 導出主要的播放函數
export function play(videoId, options = {}) {
  console.log('嘗試播放 YouTube 視頻:', videoId);
  console.log('設定播放時間:', (options.startTime || 0) + '秒', '至', options.endTime ? options.endTime + '秒' : '結束');
  
  return new Promise((resolve, reject) => {
    try {
      // 打開新窗口，使用第三個參數指定窗口特性
      const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}${options.startTime ? `&t=${options.startTime}s` : ''}`;
      const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes,status=yes';
      const newWindow = window.open(youtubeUrl, '_blank', windowFeatures);
      
      if (!newWindow) {
        console.error('無法打開新窗口，可能被瀏覽器阻止');
        reject(new Error('無法打開新窗口'));
        return;
      }
      
      // 嘗試將焦點設置到新窗口
      try {
        newWindow.focus();
      } catch (focusError) {
        console.warn('無法設置焦點到新窗口:', focusError);
      }
      
      // 記錄打開的窗口
      console.log('將新窗口添加到 openWindows 數組');
      openWindows.push(newWindow);
      console.log(`當前打開的窗口數量: ${openWindows.length}`);
      
      // 調用 onWindowOpen 回調（如果存在）
      if (options.onWindowOpen && typeof options.onWindowOpen === 'function') {
        options.onWindowOpen(newWindow);
      }
      
      // 設置結束時間處理
      let timeoutId = null;
      if (options.endTime && options.endTime > options.startTime) {
        const duration = (options.endTime - (options.startTime || 0)) * 1000;
        console.log(`設置定時器: ${duration/1000} 秒後將自動關閉窗口`);
        
        timeoutId = setTimeout(() => {
          console.log(`已到達指定結束時間 ${options.endTime} 秒，關閉窗口`);
          if (newWindow && !newWindow.closed) {
            newWindow.close();
            
            // 從列表中移除
            const index = openWindows.indexOf(newWindow);
            if (index !== -1) {
              openWindows.splice(index, 1);
              console.log(`從 openWindows 移除窗口，當前數量: ${openWindows.length}`);
            }
          }
          resolve(true); // 播放完成
        }, duration);
      }
      
      // 監聽 Q 鍵
      const handleKeyPress = (event) => {
        if (event.key === 'q' || event.key === 'Q') {
          console.log('檢測到 Q 鍵按下，關閉窗口');
          
          // 清除超時
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          
          // 關閉窗口
          if (newWindow && !newWindow.closed) {
            newWindow.close();
            
            // 從列表中移除
            const index = openWindows.indexOf(newWindow);
            if (index !== -1) {
              openWindows.splice(index, 1);
              console.log(`從 openWindows 移除窗口，當前數量: ${openWindows.length}`);
            }
          }
          
          // 移除事件監聽器
          window.removeEventListener('keydown', handleKeyPress);
          
          // 調用回調
          if (options.onQKeyPress && typeof options.onQKeyPress === 'function') {
            options.onQKeyPress();
          }
          
          resolve(true); // 播放完成
        }
      };
      
      // 添加 Q 鍵監聽
      window.addEventListener('keydown', handleKeyPress);
      
      // 監聽窗口關閉
      const checkWindowClosed = setInterval(() => {
        if (newWindow.closed) {
          console.log('檢測到窗口已關閉');
          
          // 從列表中移除
          const index = openWindows.indexOf(newWindow);
          if (index !== -1) {
            openWindows.splice(index, 1);
            console.log(`從 openWindows 移除窗口，當前數量: ${openWindows.length}`);
          }
          
          // 清除超時和間隔
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          clearInterval(checkWindowClosed);
          
          // 移除事件監聽器
          window.removeEventListener('keydown', handleKeyPress);
          
          resolve(true); // 播放完成
        }
      }, 1000);
      
      // 如果沒有設置結束時間，設置一個默認的超時
      if (!options.endTime || options.endTime <= options.startTime) {
        console.log('未設置有效的結束時間，設置默認超時時間 5 分鐘');
        setTimeout(() => {
          if (newWindow && !newWindow.closed) {
            console.log('達到默認超時時間，關閉窗口');
            newWindow.close();
            
            // 從列表中移除
            const index = openWindows.indexOf(newWindow);
            if (index !== -1) {
              openWindows.splice(index, 1);
              console.log(`從 openWindows 移除窗口，當前數量: ${openWindows.length}`);
            }
          }
          resolve(true); // 播放完成
        }, 5 * 60 * 1000); // 5分鐘
      }
      
      // 立即返回 true，表示播放已啟動
      resolve(true);
    } catch (error) {
      console.error('播放 YouTube 視頻時出錯:', error);
      reject(error);
    }
  });
}

// 導出默認對象
export default {
  play,
  closeAll,
  closeAllWindows,
  closeAllModals
}; 